module.exports = __webpack_public_path__ + "img/ill_pakket_full.3f5114a0.svg";